export default "__VITE_ASSET__pj54yd0L__"